import { TFunction } from 'i18next';
import { FieldTypeApiEnum } from 'submodules/api_middleware';
import {
    EditFieldInterface,
    FilterSize,
    LabelSize,
} from 'components/interfaces/GeneralInterface';
import { validatePostalCode } from 'utils/index';

export const getPostalCodeFormField = (
    value: string,
    t: TFunction,
    countryCodeFieldKey?: string,
    size?: FilterSize
): EditFieldInterface => ({
    name: 'address.postal_code',
    value: value,
    label: 'address.postalCode',
    type: FieldTypeApiEnum.TEXT,
    size: size || FilterSize.S15,
    labelSize: LabelSize.TOP,
    required: true,
    validate: (value, state) =>
        state[
            countryCodeFieldKey ? countryCodeFieldKey : 'address.country_code'
        ] === 'CZ'
            ? validatePostalCode(value as string, t)
            : undefined,
});
